<div class="wo-page-mobile-bar">
  <tui-app-bar class="wo-page-mobile-bar__app-bar">
    <div tuiSlot="left">
      <ng-content/>
    </div>
    <div class="wo-page-mobile-bar-title">
      <img
        [src]="'wo-common/assets/swc-logo_180x166.webp' | woFileHash"
        alt="ISS"
        class="wo-page-mobile-bar-logo"
      />

      {{ header }}
    </div>
    <button
      [icon]="'tuiIconMenuLarge'"
      title="Menu"
      tuiIconButton
      tuiSlot="right"
      (click)="toggle.emit()"
    ></button>
  </tui-app-bar>
</div>
